import React from 'react';
import { ListWrapper, LinkButton } from '@builtbypixel/nucleus';
import { Button, Badge, Text } from '@builtbypixel/plasma';

import setup from './setup';

// Extra Menu appears next to the create button
const extraMenu = () => {
    return null;
};

const List = () => {
    const columns = [
        {
            Header: 'Mosque Name',
            accessor: 'mosque.name',
        },
        {
            Header: 'Free Trial Status',
            accessor: 'free_trial_end_date',
            Cell: ({ row }) =>
                row.original.free_trial_end_date ? (
                    <Badge variantColor='success'>
                        {row.original.free_trial_end_date}
                    </Badge>
                ) : (
                    <Badge>Expired</Badge>
                ),
        },
        {
            Header: 'Plan',
            accessor: 'feature.name',
            Cell: ({ row }) => (
                <Text>
                    {row.original.feature?.name} -{' '}
                    {row.original.feature?.description}
                </Text>
            ),
        },
        {
            Header: 'Price',
            accessor: 'feature.price',
            Cell: ({ row }) => <Text>£{row.original.feature?.price}</Text>,
        },
        {
            Header: '',
            accessor: 'id',
            Cell: ({ row }) => (
                <LinkButton
                    to={`${setup.model}/edit/${row.original[setup.accessor]}`}
                >
                    <Button
                        variant='outline'
                        variantColor='primary'
                        rounded='md'
                    >
                        View Details
                    </Button>
                </LinkButton>
            ),
        },
    ];

    return (
        <ListWrapper setup={setup} columns={columns} extraMenu={extraMenu} />
    );
};

export default List;
